<script lang="ts" setup>
import { OverflowButtonProps } from "~/components/Filters/Utils/OverflowButton.props"

withDefaults(defineProps<OverflowButtonProps>(), {
  type: "button",
  nResults: 0,
  overflow: false
})

const emit = defineEmits<{ (e: "onClick"): void }>()
</script>

<template>
  <div
    class="overflow-button p-4 transition-shadow duration-300"
    :class="{ 'shadow-sticky': overflow }"
  >
    <UtilsButton
      :type="type"
      :text="`${text} (${nResults})`"
      fluid
      @click="emit('onClick')"
    />
  </div>
</template>
